document.addEventListener('DOMContentLoaded', function() {
  var controller = new ScrollMagic.Controller();
  let ele = document.getElementById('animate');
  // create a scene
  var scene = new ScrollMagic.Scene({
    duration: 500, // the scene should last for a scroll distance of 100px
    offset: 500 // start this scene after scrolling for 50px
  })
    .setPin('#animate') // pins the element for the the scene's duration
    .addTo(controller);

  scene.on('progress', function(event) {
    ele.style.transform = `scale(${1 +
      event.progress}) translateY(${event.progress * 120}px)`;
    ele.style.backgroundColor = `rgb(14, 20, 54, ${event.progress})`;
  });
});
